import React from 'react';
import { Typography } from '@mui/material';
import { motion } from 'framer-motion';
import logo from '../../../assets/logo/square.png';
import { BackgroundContainer, LogoContainer, CenterBox } from './Login.styles';
import SocialAuth from '../Onboarding/components/SocialAuthentication/SocialAuth';

const Login = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      style={{ height: '100vh', width: '100vw' }}
    >
      <BackgroundContainer>
        <LogoContainer>
          <img
            src={logo}
            alt="Tempo Logo"
            style={{ width: '40px', height: '40px', marginRight: '10px' }}
          />
          <Typography variant="h6" color="white">
            Tempo
          </Typography>
        </LogoContainer>
        <CenterBox>
          <SocialAuth />
        </CenterBox>
      </BackgroundContainer>
    </motion.div>
  );
};

export default Login;